import { render } from "./NavBar.vue?vue&type=template&id=14b1524e&scoped=true"
const script = {}

import "./NavBar.vue?vue&type=style&index=0&id=14b1524e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b1524e"]])

export default __exports__